/* eslint-disable import/no-anonymous-default-export */
import {
  CREATEPRODUCT,
  UPDATEPRODUCT,
  DELETEPRODUCT,
  FETCHPRODUCT,
  FETCH_ALLPRODUCTS,
  UPDATEPRODUCTGALLERY,
  DELETEIMAGE,
} from "../constants/actionTypes";

export default (products = [], action) => {
  switch (action.type) {
    case DELETEPRODUCT:
      return products?._id !== action?.payload?._id;
    case UPDATEPRODUCT:
      return products?._id === action?.payload._id ? action?.payload : products;
    case FETCH_ALLPRODUCTS:
      return action.payload;
    case FETCHPRODUCT:
      return action.payload;
    case CREATEPRODUCT:
      return [...products, action.payload];
    case UPDATEPRODUCTGALLERY:
      return action.payload;
    case DELETEIMAGE:
      return products?.images?.filter((image) => image !== action.payload);
    default:
      return products;
  }
};
